import '@vfde-brix/system-icon/dist/styles.css';
import '@vfde-brix/icon/dist/styles.css';
import { createIconComponent } from '@vfde-brix/icon';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';
import { createComponents } from '../../utils/initComponents';

createComponents('brix-icon-pattern', createIconComponent, NO_PATTERN_BUSINESS_LOGIC);
